module.exports = __webpack_public_path__ + "media/images/games/fifa-23/hiw-3-06d69a28d074f81a7363766d7d2409f7.jpg";